<template>
    <div>
        <div style="padding: 0 20px;  ">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between;">
                <div>
                    <el-select v-model="query.state" size="small" style="width: 120px;margin-left: 20px">                        
                        <el-option key="INIT" label="待审核" value="INIT"></el-option>
                        <el-option key="CHECK_SUCC" label="审核成功" value="CHECK_SUCC"></el-option>
                        <el-option key="CHECK_FAIL" label="审核失败" value="CHECK_FAIL"></el-option>
                    </el-select>
                    <el-date-picker size="small" v-model="query.startTime" type="date" placeholder="开始时间" style="width: 120px;margin-left: 20px"></el-date-picker>
                    <el-date-picker  size="small" v-model="query.endTime" type="date" placeholder="结束时间" style="width: 120px;margin-left: 20px"></el-date-picker>
                    <el-input size="small" v-model="query.accountName"                             
                              placeholder="请输入账户名称"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px">
                    </el-input>
                   <el-button type="primary" size="small"  @click="search" style="width: 68px;margin-left: 20px">查询</el-button>
                   <el-button type="primary" size="small"  @click="dataExport" style="width: 78px;">批量导出</el-button>
                    <el-button type="primary" size="small"  @click="batchAudit" style="width: 78px;">批量审核</el-button>
                    <el-button type="primary" size="small"  @click="batchPayment" style="width: 78px;">批量打款</el-button>
                </div>
        
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="医生姓名" prop="doctorName"></el-table-column>
                    <el-table-column label="时间" prop="creationTime" :formatter="dateFormat"></el-table-column>
                    <el-table-column label="账户名" prop="userName"></el-table-column>
                    <el-table-column label="机构" prop="title"></el-table-column>
                    <el-table-column label="身份证号" prop="idCard"></el-table-column>
                    <el-table-column label="银行名称" prop="bankName"></el-table-column>
                    <el-table-column label="开户支行" prop="openAccountBank"></el-table-column>
                    <el-table-column label="当月累计提现" prop="withdrawAmount"></el-table-column>
                    <el-table-column label="需转账金额" prop="money"></el-table-column>
                    <el-table-column label="申请金额" prop="moneyApply"></el-table-column>
                    <el-table-column label="纳税金额" prop="moneyTax"></el-table-column>
                    <el-table-column label="提现类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.withdrawalState === 0">支付宝</span>
                            <span v-else>银行卡</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="角色">
                        <template slot-scope="scope">
                            <span v-if="scope.row.userState === 0">医生</span>
                            <span v-else>销售</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.auditState === 0">待审核</span>
                            <span v-else-if="scope.row.auditState === 1">审核成功</span>
                            <span v-else>审核失败</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span v-if="scope.row.auditState == 0">
                              <el-button type="text" @click="auditSucc(scope.row)">通过</el-button>
                              <el-button type="text" @click="auditFail(scope.row)">拒绝</el-button>
                            </span>
                            <span v-if="scope.row.auditState == 1">
                              <el-button type="text" @click="payment(scope.row)">打款</el-button>  
                            </span>                       
                        </template>
                    </el-table-column>
                    
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>       
     <el-dialog title="打款确认" :visible.sync="dialogPaymentVisible" width="560px" :close-on-click-modal="false">
            <el-form :model="paymentEdit"  :rules="rule" label-width="100px" size="small">
<!--                <el-form-item label="角色:" prop="userRole">-->

<!--                    <el-radio-group v-model="paymentEdit.userRole" @change="roleChange">-->
<!--                            <el-radio label="DOCTOR" >医生</el-radio>-->
<!--                            <el-radio label="SALE" >业务员</el-radio>-->
<!--                    </el-radio-group>-->

<!--                </el-form-item>-->
                <el-form-item label="姓名:" prop="paymentName">
                    <el-input v-model="paymentEdit.paymentName" placeholder="请输入姓名" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="联系方式:" prop="paymentPhone">
                        <el-input v-model="paymentEdit.paymentPhone" placeholder="请输入联系方式" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="打款金额:" prop="paymentAmount">
                        <el-input v-model="paymentEdit.paymentAmount" placeholder="请输入打款金额" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="dialogPaymentVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmPayment" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {        
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {                    
                    state: 'INIT', 
                    startTime:'',
                    endTime:'',
                    accountName:''

                },
               
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],                
                dialogPaymentVisible:false,
                paymentEdit:{
                    userId:'',
                    userRole:'DOCTOR',
                    withdrawNo:'',
                    paymentPhone:'',
                    paymentAmount:''
                },
                 rule:{
                    paymentPhone:[{required: true, message: '请输入联系方式', trigger: 'blur'}],                   
                    paymentAmount: [{required: true, message: '请输入打款金额', trigger: 'blur'}],
                                        
                },
                multipleSelection:[],
                selectedNos:[],

            }
        },

        methods: {
            
            // 获取列表数据
            getData() {                               
                this.loading = true
                let params = {                    
                    state: this.query.state,
                    startTime:this.query.startTime,
                    endTime:this.query.endTime,
                    accountName:this.query.accountName               
                }                
                this.axios.post('/api-b/10052/100520/' + this.pageNum + '/' + this.pageSize,params,{                    
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total                            
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
                
            },            
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            search(){
                this.getData()
            },
            dataExport(){
                this.axios.get('/api-b/10052/100523',{
                    params:{
                       state: this.query.state,
                       startTime:this.query.startTime,
                       endTime:this.query.endTime, 
                    },
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })

            },
            auditSucc(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要通过该提现吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = {
                        withdrawalNo:data.withdrawNo,
                        state:'CHECK_SUCC'
                    }                    
                    this.axios.post('/api-b/10052/100521',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })            
                   
            },
            auditFail(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要拒绝该提现吗？'),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {                    
                    let params = {
                        withdrawalNo:data.withdrawNo,
                        state:'CHECK_FAIL'
                    }         
                    this.axios.post('/api-b/10052/100521',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })            
                   
            },
            payment(data){
                let userName = data.userName
                let bankName = data.bankName
                //alert(bankName)
                this.axios.get('/api-b/10052/100900',{
                    params : {
                        doctorName: userName,
                        bankName: bankName,
                    },
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    //alert(JSON.stringify(res.data))
                    this.paymentEdit.userId = data.userId,
                    this.paymentEdit.withdrawNo = data.withdrawNo,
                    this.paymentEdit.paymentPhone = res.data.data.phone,
                    this.paymentEdit.paymentAmount = data.moneyApply,
                    this.paymentEdit.paymentName = data.userName
                    this.dialogPaymentVisible = true

                })
                /*this.paymentEdit.userId = data.userId,
                this.paymentEdit.userRole = 'DOCTOR',
                this.paymentEdit.withdrawNo = data.withdrawNo,
                this.paymentEdit.paymentPhone = data.doctorPhone,
                this.paymentEdit.paymentAmount = data.moneyApply,
                this.paymentEdit.paymentName = data.doctorName
                this.dialogPaymentVisible = true
                this.roleChange('DOCTOR')*/
            },
            /*roleChange(data){
                if(data == 'SALE'){
                    this.axios.get('/api-b/10060/100600/' + this.paymentEdit.userId, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.paymentEdit.paymentPhone = res.data.data.phoneNumber
                            this.paymentEdit.paymentName = res.data.data.nickName
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    this.axios.get('/api-b/10052/100524/' + this.paymentEdit.withdrawNo, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.paymentEdit.paymentPhone = res.data.data.doctorPhone
                            this.paymentEdit.paymentName = res.data.data.doctorName
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }

            },*/
            confirmPayment(){
                let params = {
                    withdrawNo:this.paymentEdit.withdrawNo,
                    paymentPhone:this.paymentEdit.paymentPhone,
                    paymentAmount:this.paymentEdit.paymentAmount
                    
                }
                this.axios.post('/api-b/10052/100522',params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                               
                                this.dialogPaymentVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
            },
            dateFormat:function(row,column){
            
            var date = new Date(row.creationTime);
            
            if(date == undefined){return ''};
            var dateTypeDate = "";
            dateTypeDate += date.getFullYear();   //年
            dateTypeDate += "-" + (date.getMonth()+1); //月
            dateTypeDate += "-" + date.getDate();  //日
            dateTypeDate += ' '
            dateTypeDate += date.getHours();
            dateTypeDate += ":"+date.getMinutes();
            dateTypeDate += ":"+date.getSeconds();
            return dateTypeDate;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection)
            let ids = []
            this.multipleSelection.map((item)=> {
                ids.push(item.withdrawNo)
            })
            this.selectedNos = ids
            console.log('多选',this.selectedNos)
        },
        batchAudit(){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要批量审核提现吗？'),
                    ])
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let params = {
                    withdrawalNos:this.selectedNos,
                    state:'CHECK_SUCC'
                }
                this.axios.post('/api-b/10052/100525',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        },
        batchPayment(){
                console.log(this.selectedNos)
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要批量打款吗？'),
                    ])
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let params = {
                    withdrawalNos:this.selectedNos,
                }
                this.axios.post('/api-b/10052/100526',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        }

        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
            
        },
        created() {            
            this.getData()          
            
        }
    }

    function revertUTF8(szInput) {
    var x,wch,wch1,wch2,uch="",szRet="";
    for (x=0; x<szInput.length; x++) {
        if (szInput.charAt(x)=="%") {
            wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
            if (!wch) {break;}
            if (!(wch & 0x80)) {
                wch = wch;
            } else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x1F)<< 6;
                wch1 = wch1 & 0x3F;
                wch  = wch + wch1;
            } else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x0F)<< 12;
                wch1 = (wch1 & 0x3F)<< 6;
                wch2 = (wch2 & 0x3F);
                wch  = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        } else {
            szRet += szInput.charAt(x);
        }
    }
    return(szRet);
}

</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
    .tag-box {
            width: 288px;
            min-height: 30px;
            border-radius: 5px;
            border: 1px solid #DCDFE6;
            padding: 0 15px
        }
</style>